
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OAuthService } from './oauth.service';
import { DialogService } from './dialog.service';


// Import RxJs required methods



@Injectable()
export class RequestHistoryService {
    public static get FORMAT_HTML(): string { return "HTML"; };
    public static get FORMAT_PDF(): string { return "PDF"; };

    // Resolve HTTP using the constructor
    constructor(private http: HttpClient,
    private dialogService: DialogService) { }

    downloadPDF(url,format): any {
        const headers = new HttpHeaders({
         'Content-Type': 'application/json' ,
         'Authorization': `Bearer ${OAuthService.getAccessToken()}`
         });
        return this.http.get(url, { responseType: "blob", headers: headers }).pipe(map(
            (res : Blob) => {
              if(format === RequestHistoryService.FORMAT_HTML)
                return new Blob([res], { type: 'text/html' });
              else if (format === RequestHistoryService.FORMAT_PDF)
                return new Blob([res], { type: 'application/pdf' });
                else
                  return new Blob([res], { type: 'application/octet-stream' });
            },
            (err) => {
              console.log(err);
            } ));
    }

    downloadPDFFromSMS(url,format): any {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', `Bearer ${OAuthService.getDownloadToken()}`);
        this.http.get(url,{responseType: "blob" }).subscribe(
          (res : Blob) => {
              console.log('inside downloadPDFFromSMS');
              if (format === RequestHistoryService.FORMAT_HTML) {
                return new Blob([res], { type: 'text/html' });
              }
              else if (format === RequestHistoryService.FORMAT_PDF) {
                let file = new Blob([res], { type: 'application/pdf' });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL,"_self");
              }
              else {
                let file = new Blob([res], { type: 'application/octet-stream' });
                let fileURL = URL.createObjectURL(file);
                window.open(fileURL,"_self");
              }
          },
          (err) => {
             let message = 'Could not open pdf file, token might have expired.';
             this.dialogService.openErrorDialogRefreshAfterClosing( {message} );
          });
    }
}
